import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Flex Container */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start text-center lg:text-left space-y-8 lg:space-y-0 lg:space-x-8">
          
          {/* Business Info */}
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-4">Aggarwal Tax & Accounting Services</h3>
            <p className="text-gray-400">41 Deforest Dr, Brampton ON L7A 2Y1, Canada</p>
            <p className="text-gray-400">Pankajaggarwaltaxguy@gmail.com</p>
            <p className="text-gray-400">+1 647 960 1930</p>
          </div>

          {/* Quick Links */}
          <div className="flex-1 text-center">
            <h3 className="text-2xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {["Forms", "Aboutus", "Contactus"].map((link, index) => (
                <li key={index}>
                  <a href={`/${link.toLowerCase().replace(/\s+/g, "-")}`} className="text-gray-400 hover:text-white transition">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div className="flex-1 text-center">
            <h3 className="text-2xl font-bold mb-4">Follow Us</h3>
            <div className="flex justify-center space-x-6 text-4xl">
              <a href="https://www.facebook.com/people/Aggarwal-Tax-Accounting-Services/100066809882955/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-400 transition">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="mailto:Pankajaggarwaltaxguy@gmail.com" className="text-white hover:text-gray-400 transition">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
              <a href="https://www.linkedin.com/in/pankajaggarwal-tax/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-400 transition">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>

         {/* Accounting Apps */}
<div className="flex-1 text-center">
  <h3 className="text-2xl font-bold mb-4">Our Accounting Apps</h3>
  <div className="flex justify-center items-center gap-4">
    <img src="/images/profile.png" alt="Excel" className="w-12 h-12 object-contain" />
    <img src="/images/exel2.png" alt="Excel" className="w-12 h-12 object-contain" />
    <img src="/images/intuit2.png" alt="Intuit" className="w-12 h-12 object-contain" />
    <img src="/images/intut.png" alt="Intuit" className="w-12 h-12 object-contain" />

  </div>
  {/* <img src="/images/qbook.png" alt="Intuit" className=" h-12 object-contain" /> */}

</div>

        </div>

        {/* Footer Bottom */}
        <div className="mt-12 border-t border-gray-600 pt-6 text-center text-gray-400">
          <p>
            Powered by <span className="font-semibold text-white">Alif Dynamics Inc. Canada 2025</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileExcel, faChartLine, faClipboardList, faEnvelope } from "@fortawesome/free-solid-svg-icons";
// import { faFacebook, faLinkedin } from "@fortawesome/free-brands-svg-icons";

// const Footer = () => {
//   return (
//     <footer className="bg-gray-800 text-white py-12">
//       <div className="max-w-7xl mx-auto px-6 lg:px-12">
//         {/* Grid Layout for Equal Spacing */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-8 text-center lg:text-left">
//           {/* Business Information */}
//           <div>
//             <h3 className="text-2xl font-bold mb-4">Aggarwal Tax & Accounting Services</h3>
//             <p className="text-gray-400">41 Deforest Dr, Brampton ON L7A 2Y1, Canada</p>
//             <p className="text-gray-400">Pankajaggarwaltaxguy@gmail.com</p>
//             <p className="text-gray-400">+1 647 960 1930</p>
//           </div>

//           {/* Quick Links */}
//           <div className="flex flex-col items-center justify-center h-full">
//   <h3 className="text-2xl font-bold mb-4 text-center">Quick Links</h3>
//   <ul className="space-y-2 text-center">
//     {["forms", "aboutus", "contactus"].map((link, index) => (
//       <li key={index}>
//         <a
//           href={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
//           className="text-gray-400 hover:text-white transition"
//         >
//           {link}
//         </a>
//       </li>
//     ))}
//   </ul>
// </div>


//           {/* Social Media Links */}
//           <div>
//             <h3 className="text-2xl font-bold mb-4 text-center">Follow Us</h3>
//             <div className="flex justify-center space-x-6 text-4xl">
//               <a 
//               target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/people/Aggarwal-Tax-Accounting-Services/100066809882955/" className="text-white hover:text-gray-400 transition">
//                 <FontAwesomeIcon icon={faFacebook} />
//               </a>
//               <a href="mailto:Pankajaggarwaltaxguy@gmail.com" className="text-white hover:text-gray-400 transition">
//                 <FontAwesomeIcon icon={faEnvelope} />
//               </a>
//               <a 
//               target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/pankajaggarwal-tax/" className="text-white hover:text-gray-400 transition">
//                 <FontAwesomeIcon icon={faLinkedin} />
//               </a>
//             </div>
//           </div>

//           {/* Legal Information */}
//           <div>
//             <h3 className="text-2xl font-bold mb-4 text-center">Our Accounting Apps</h3>
//             <div className="flex justify-center text-center gap-3 space-x-6">
//               <img src="/images/exel.jpg" alt="Excel" className="w-28 h-12" />
//               <img src="/images/intuit1.jpg" alt="Intuit" className="w-28 h-12" />
//             </div>
//             <img src="/images/qbook.png" alt="ProviderSoft" className=" mt-4" />

//             {/* <p className="text-gray-400 mt-4">© 2025, Aggarwal. All Rights Reserved.</p> */}
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="mt-12 border-t border-gray-600 pt-6 text-center text-gray-400">
//           <p>
//             Powered by <span className="font-semibold text-white">Alif Dynamics Inc. Canada 2025</span>
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
